var borderRadius = {
    "sm": "2px",
    "md": "4px",
    "lg": "8px",
    "xl": "16px",
};

export { borderRadius as default };
//# sourceMappingURL=borderRadius.js.map
